module.exports = __webpack_public_path__ + "img/chart_widget_line.5ce8b15.svg";